import Vuex from 'vuex'
import Vue from 'vue'
import { getField, updateField } from 'vuex-map-fields'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth: {
      loginuser: '',
      placeid: '',
      phoneNumber: '',
      username: '',
      fbuser: null,
      admin: false,
      prod: '',
      user_mail: '',
    },
    showing: {
      preloader: false,
      VizsgaDetails_show: false,
      Vizsgak_show: true,
      DiakokDetails_show: false,
      Diakok_show: true,
      Tanfolyamok_show: true,
      TanfolyamokDetails_show: false
    },
    exam_details: {
      exam_gui_id: '',
      exam_id: '',
      new_exam_id: '',
      exam_date: '',
      exam_time: '',
      school_select: null,
      exam_location: null,
      det_resp: '',
      student_exam_result: '',
    },
    course_details: {
      course_id: '',
      course_student_id: '',
      nkh_course_type_id: '',
      course_number: '',
      course_data_id: '',
      is_GKI: false,
      training_type: '',
    },
    tanfolyamok: {
      course_id: '',
      course_number: '',
      course_start: '',
      course_end: '',
      place_name: '',
      place_id: '',
      course_type: '',
      course_type_id: '',
      nkh_course_type_id: '',
      course_pattern: '',
      driving_school_id: '',
      nkh_user_name: '',
      lessons: [],
      tanrend_upload: false,
      nevsor_upload: false,
      headcount_update: false,
      students: false,
      public_limit: '',
    },
    diakok_details: {
      contract_id: '',
      contract_type: '',
      course_type: '',
      school_id: '',
      contract_date: '',
      customer_id: '',
      archived: '',
      search: '',
      searching: false,
      picked: 'false',
      student_type: 'student',
      full_name: '',
      birthdate: '',
      phone1: '',
      email1: '',
      student_course_details: [],
      diakok_tab: 0,
      titanId: '',
    }
  },

  getters: { // preloader státusz változás követéshez szükséges funkció
    // preloader: state => state.preloader,
    getField

  },

  mutations: { // külső hozzáféréshez (adatmódosításhoz) szükséges funkció
    /* preload(state, payload) {             // store.commit('preload', true) - funkció meghívása külső componensből
    state.preloader = payload;
  }, */
    updateField

  },

  actions: {
    // Here we will create Larry
  }
})
